/**
 * @param {number} currencyValue
 */

export function formatCurrencyWithoutFraction(currencyValue, maxFractionDigits = 0) {
  if (isNaN(currencyValue)) {
    return parseFloat(
      currencyValue
        .toString()
        .replace(/\./g, '')
        .replace(/,/g, '.'),
    ).toLocaleString('pt-BR', {
      currency: 'BRL',
      maximumFractionDigits: maxFractionDigits,
      minimumFractionDigits: maxFractionDigits,
    });
  }
  return parseFloat(currencyValue).toLocaleString('pt-BR', {
    currency: 'BRL',
    maximumFractionDigits: maxFractionDigits,
    minimumFractionDigits: maxFractionDigits,
  });
}
